import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68e8c707"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pl-6 mb-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Version: ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Lizenz: ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Link: ", -1))
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserDialogButton = _resolveComponent("UserDialogButton")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_toolbar = _resolveComponent("toolbar")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_toolbar, {
        title: _ctx.t('toolbar.impressum')
      }, {
        trailing: _withCtx(() => [
          _createVNode(_component_UserDialogButton)
        ]),
        leading: _withCtx(() => [
          _createVNode(_component_ion_buttons, { slot: "start" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_button, {
                fill: "clear",
                color: "light",
                class: "px-0 -ml-4",
                size: "small",
                onClick: _cache[0] || (_cache[0] = () => _ctx.goBackToLandingPage())
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.arrowBack,
                    size: "large"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_ion_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card_header, { class: "py-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_title, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.t("libraries.titel")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card_content, { class: "container" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.licenseReport, (library, index) => {
                        return (_openBlock(), _createBlock(_component_ion_col, {
                          key: library,
                          size: "6",
                          "size-xs": "12",
                          "size-sm": "12",
                          "size-md": "6",
                          "size-lg": "6",
                          "size-xl": "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card, { class: "adjust-size" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card_title, { class: "pt-5 pl-5 ion-text-left" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(library.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_card_content, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("ul", null, [
                                      _createElementVNode("li", null, [
                                        _hoisted_2,
                                        _createTextVNode(" " + _toDisplayString(library.installedVersion), 1)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _hoisted_3,
                                        _createTextVNode(" " + _toDisplayString(library.licenseType), 1)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _hoisted_4,
                                        _createElementVNode("a", {
                                          href: _ctx.licenseReport[index].link
                                        }, _toDisplayString(library.link), 9, _hoisted_5)
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}